import React from 'react'
import '@loyal_template/placeholder.css'
const ServicesPlaceholder = () => (
  <div className='bx-showcase'>
    <div className='container-fluid bg-white pt-3'>
      <div className='container'>
        <div className='row'>
          <div className='col-12 mb-2 mx-1 px-0'>
            <div className='row mx-0 shimmer'>
              <div className='col-6 py-half bg-ui-3 radius' />
            </div>
          </div>
        </div>
        <div className='row row-eq-height'>
          <div className='col-12 col-md-4 mb-4'>
            <div className='bg-image-gray border-ui-4 bg-white radius row px-2 mx-0 pt-3 pb-2'>
              <div className='col-12'>
                <div className='row mx-0 shimmer'>
                  <div className='col-6 py-half bg-ui-2 radius' />
                </div>
                <div className='row mx-0 mt-2 shimmer'>
                  <div className='col-11 py-half bg-white radius' />
                </div>
                <div className='row mx-0  mt-1 shimmer'>
                  <div className='col-8 py-half bg-white radius' />
                </div>
              </div>
              <div className='col-12 mr-auto ml-auto bg-white mt-2  border-ui-4 py-1'>
                <div className='row mx-0'>
                  <div className='col-12'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>
                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>
                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>

                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4 mb-4'>
            <div className='bg-image-gray border-ui-4 bg-white radius row px-2 mx-0 pt-3 pb-2'>
              <div className='col-12'>
                <div className='row mx-0 shimmer'>
                  <div className='col-6 py-half bg-ui-2 radius' />
                </div>
                <div className='row mx-0 mt-2 shimmer'>
                  <div className='col-11 py-half bg-white radius' />
                </div>
                <div className='row mx-0  mt-1 shimmer'>
                  <div className='col-8 py-half bg-white radius' />
                </div>
              </div>
              <div className='col-12 mr-auto ml-auto bg-white mt-2  border-ui-4 py-1'>
                <div className='row mx-0'>
                  <div className='col-12'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>
                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>
                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>

                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4 mb-4'>
            <div className='bg-image-gray border-ui-4 bg-white radius row px-2 mx-0 pt-3 pb-2'>
              <div className='col-12'>
                <div className='row mx-0 shimmer'>
                  <div className='col-6 py-half bg-ui-2 radius' />
                </div>
                <div className='row mx-0 mt-2 shimmer'>
                  <div className='col-11 py-half bg-white radius' />
                </div>
                <div className='row mx-0  mt-1 shimmer'>
                  <div className='col-8 py-half bg-white radius' />
                </div>
              </div>
              <div className='col-12 mr-auto ml-auto bg-white mt-2  border-ui-4 py-1'>
                <div className='row mx-0'>
                  <div className='col-12'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-4 radius' />
                    </div>
                  </div>
                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-4 radius' />
                    </div>
                  </div>
                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-4 radius' />
                    </div>
                  </div>

                  <div className='col-12 mt-1'>
                    <div className='row ml-0'>
                      <div className='col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-3 radius' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default ServicesPlaceholder



// WEBPACK FOOTER //
// ./src/features/Services/ServicesPlaceholder.js